export const STORAGE_KEYS = {
  LOCAL_STORAGE_KEY: 'localStorage',
  SESSION_STORAGE_KEY: 'sessionStorage',
} as const;
export type STORAGE_KEYS_TYPE =
  (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
